export const STATUS_CLASSES: Record<string, string> = {
	rejected: 'bg-danger bg-opacity-10 text-danger border border-danger',
	selected: 'bg-success bg-opacity-10 text-success border border-success',
	shortlisted: 'bg-success bg-opacity-10 text-success border border-success',
	applied: 'bg-info bg-opacity-10 text-info border border-info',
	pending: 'bg-dark bg-opacity-50 text-muted border border-light',
	hold: 'bg-warning bg-opacity-50 text-muted border border-warning',
	offer_sent: 'bg-success bg-opacity-10 text-success border border-success',
	offer_save: 'bg-success bg-opacity-10 text-success border border-success',
	offer_rejected: 'bg-danger bg-opacity-10 text-danger border border-danger',
	offer_accepted: 'bg-success bg-opacity-10 text-success border border-success',
	default: 'bg-secondary bg-opacity-10 text-secondary border border-secondary',
};
export const STATUS_CIRCLE_CLASSES = {
	default: 'bg-dark bg-opacity-50 text-muted border border-light',
	rejected: 'bg-danger border border-danger',
	selected: 'bg-success border border-success',
	hold: 'bg-warning border border-warning',
	shortlisted: 'bg-success border border-success',
	applied: 'bg-info border border-info',
	offer_sent: 'bg-success border border-success',
	offer_save: 'bg-success border border-success',
	offer_rejected: 'bg-danger border border-danger',
	offer_accepted: 'bg-success border border-success',
};

// for Button Status on Candidate History
export const statusClasses: Record<string, string> = {
	hold: 'btn btn-light-warning',
	applied: 'btn btn-light-info ',
	rejected: 'btn btn-light-danger',
	shortlisted: 'btn btn-light-success ',
	not_shortlisted: 'btn btn-light-danger ',
	scheduled: 'btn btn-light-warning',
	offer_sent: 'btn btn-warning',
	offer_save: 'btn btn-success',
	offer_accepted: 'btn btn-light-success',
	offer_rejected: 'btn btn-light-danger ',
	default: 'btn btn-light-secondary ',
};
